var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShieldLowRisk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "shield-low-risk",
    xmlns: "http://www.w3.org/2000/svg",
    width: 72.132,
    height: 82.435,
    viewBox: "0 0 72.132 82.435",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_3",
    "data-name": "Exclusion 3",
    d: "M36.065,82.435A10.612,10.612,0,0,1,31.8,81.2a36.91,36.91,0,0,1-5.4-3.22A60.586,60.586,0,0,1,13.429,65.343C5.832,55.409-2.538,38.412.726,13.87a7.983,7.983,0,0,1,5.383-6.5c4.843-1.591,9.848-3.1,14.873-4.483C28.129.942,33.063,0,36.065,0S44,.942,51.152,2.886C56.72,4.391,62.314,6.155,66.027,7.369a7.969,7.969,0,0,1,5.378,6.5c3.268,24.542-5.1,41.538-12.7,51.473A60.548,60.548,0,0,1,45.735,77.98a36.638,36.638,0,0,1-5.4,3.22A10.694,10.694,0,0,1,36.065,82.435ZM20.477,34.954a3.755,3.755,0,0,0-2.657,6.41L29.075,52.618a3.731,3.731,0,0,0,2.653,1.1,3.781,3.781,0,0,0,2.657-1.1l22.5-22.5a3.719,3.719,0,0,0,1.1-2.654,3.773,3.773,0,0,0-1.1-2.657,3.749,3.749,0,0,0-5.31,0L31.728,44.659l-8.594-8.606A3.737,3.737,0,0,0,20.477,34.954Z",
    transform: "translate(0)",
    fill: "#21b537"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldLowRisk);
export default __webpack_public_path__ + "static/media/shield-low-risk.a3f1760a5e23a35b5b0688815a224742.svg";
export { ForwardRef as ReactComponent };